import { ITrackingProvider, TrackingProviderTypeEnum } from '@quadminds/shared/tracking-system';
import { DeviceTypeEnum } from '../enums';

export const getDeviceTypeByProvider = (provider: ITrackingProvider): DeviceTypeEnum =>
    provider.type === TrackingProviderTypeEnum.GPS ? DeviceTypeEnum.GPS : DeviceTypeEnum.INTEGRATION;

/**
 * Pure check so it can run both in Nest services (thrown as BadRequestException) and
 * in isomorphic form schemas, without this shared lib depending on @nestjs/common.
 */
export const findTrackingProviderError = (
    trackerType: string | undefined,
    deviceType: DeviceTypeEnum | undefined,
    providers: ITrackingProvider[],
): string | null => {
    if (!trackerType) return null;

    const provider = providers.find((p) => p.name === trackerType);
    if (!provider) {
        return `trackerType "${trackerType}" is not a registered tracking provider. Must be one of: ${providers
            .map((p) => p.name)
            .join(', ')}`;
    }

    const expectedDeviceType = getDeviceTypeByProvider(provider);
    if (deviceType && expectedDeviceType !== deviceType) {
        return `trackerType "${trackerType}" is a ${provider.type} provider; device.type must be "${expectedDeviceType}" (received "${deviceType}")`;
    }

    return null;
};
